import lazyLoading from '../../utils/lazyLoading'

export default {
  hidden: false,
  createroutes: true,
  name: 'admin_security',
  meta: {
    label: 'Toegangsbeheer',
    permission: 'ADSV',
    icon: 'mdi-security',
    expanded: false
  },
  children: [
    {
      name: 'admin_security_groups',
      path: '/admin/security/groups/',
      meta: {
        label: 'Groepen',
        icon: 'mdi-security',
        permission: 'ADSG'
      },
      component: lazyLoading('admin/security/Groups')
    },
    {
      name: 'admin_security_rules',
      path: '/admin/security/rules/',
      meta: {
        label: 'Regels',
        icon: 'mdi-security',
        permission: 'ADSR'
      },
      component: lazyLoading('admin/security/Rules')
    }]
  /* ,
  {
    name: 'Leden',
    path: '/admin/members',
    meta: {
      permission: '*',
      link: 'admin/Members.vue'
    },
    component: lazyLoading('admin/Members')
  } */
}



// WEBPACK FOOTER //
// ./src/store/menu/security.js